
import ProductCard from 'Vue/components/shared/ProductCard.vue';
import { variantGrouping, wishlistResponse, wishlistTranslations } from 'Vue/interfaces/WishlistInterfaces';
import { GetProductData } from 'Api/apis';

declare var __sharethis__: any;

export default {
    name: 'Wishlist',
    components: {
        ProductCard,
    },
    data() {
        return {
            loadingResults: false,
            ProductIdsString: null,
            ProductIds: [] as string[],
            products: [] as variantGrouping[],
            translations: {} as wishlistTranslations,
        };
    },
    methods: {
        async getWishlistProducts() {
            const queryParams = new URLSearchParams(window.location.search);
            if (queryParams.has('slugs')) {
                this.ProductIdsString = queryParams.has('slugs') ? queryParams.get('slugs') : null;
                this.productIds = this.ProductIdsString.split(',');
                this.isSharedMode = true;
            }
            this.loadingResults = true;
            let request = this.$store.getters?.wishlistRequest;
            this.getAllProductKeys(request);
            if (request.slugs?.length > 0) {
                const responseData: wishlistResponse = await GetProductData(request);
                this.products = responseData.products;
            }
            this.loadingResults = false;
        },
        getAllProductKeys(request): void {
            let keyName = 'wishlist-products';
            if (localStorage.getItem(keyName)) {
                let slugs = JSON.parse(localStorage.getItem(keyName));
                this.productIdsString = slugs.toString();
                // Eliminate any null product Slugs
                for (let i = slugs.length - 1; i >= 0; i--) {
                    if (slugs[i] == null) {
                        slugs.splice(i, 1);
                    }
                }
                request.slugs = slugs;
            }
        },        
        loadShareThis() {  
            const buttons = document.querySelector('.sharethis-inline-share-buttons')
            var newUrl = window.location.href + `?slugs=` + this.productIdsString;
            buttons.setAttribute('data-url', newUrl ) 
            __sharethis__.initialize();
        },
      
        baseUrl() {
            return window.location.pathname;
        },
        doPrint(e) {
            e.preventDefault();
            window.print();
        },
        getTranslations() {
            let wishlistDataDiv = document.getElementById('wishlistTranslationsData');
            return JSON.parse(wishlistDataDiv.getAttribute('data-translations'));
        },
        removeFavoriteProduct: function(product) {
            var index = this.products.findIndex( (i) => i.variantSlug === product.variantSlug);
            if (index !== -1) {
                this.products.splice(index, 1 );
            }
        }
    },
    async created() {
        this.translations = this.getTranslations();
        await this.getWishlistProducts();
        this.loadShareThis();
    },
};
